export const menu1 = [{
  title: 'Solutions',
  link: '#solutions'
}, {
  title: 'Pricing',
  link: '#pricing'
}, {
  title: 'Docs',
  link: '#docs'
}, {
  title: 'More',
  link: '#more'
}]

export const menu2 = [{
  title: 'Product',
  link: '#product'
}, {
  title: 'Features',
  link: '#features'
}, {
  title: 'Marketplace',
  link: '#marketplace'
}, {
  title: 'Company',
  link: '#company'
}]

export const mymenu = [{
  title: 'Email',
  link: 'mailto:whshen@gapp.nthu.edu.tw'
}, {
  title: 'GitHub',
  link: 'https://github.com/Rabbit1010/'
}, {
  title: 'Google Scholar',
  link: 'https://scholar.google.com/citations?hl=zh-TW&authuser=1&user=VsIrznEAAAAJ'
}]

export default {
  menu1,
  menu2,
  mymenu
}
